import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ITemplateMutator2hgxu9b9sapxu as ITemplateMutator,
  ISchedulingMutator2o3geodc2adgx as ISchedulingMutator,
} from './Shared7Punches-data-scheduling.mjs';
import { IShiftAccessor1pahto1t0k4qo as IShiftAccessor } from './Shared7Punches-domain-shift-domain.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IFillScheduleFromTemplateUseCase, 'IFillScheduleFromTemplateUseCase', VOID, VOID, VOID, [2]);
initMetadataForClass(FillScheduleFromTemplateUseCase, 'FillScheduleFromTemplateUseCase', VOID, VOID, [IFillScheduleFromTemplateUseCase], [2, 3, 1]);
//endregion
function get_schedulingFeatureModule() {
  _init_properties_SchedulingFeatureModule_kt__cs82uc();
  return schedulingFeatureModule;
}
var schedulingFeatureModule;
function schedulingFeatureModule$lambda($this$module) {
  _init_properties_SchedulingFeatureModule_kt__cs82uc();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = schedulingFeatureModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IFillScheduleFromTemplateUseCase), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function schedulingFeatureModule$lambda$lambda($this$factory, it) {
  _init_properties_SchedulingFeatureModule_kt__cs82uc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITemplateMutator), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IShiftAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(ISchedulingMutator), null, null);
  return new FillScheduleFromTemplateUseCase(tmp, tmp_0, tmp$ret$2);
}
var properties_initialized_SchedulingFeatureModule_kt_8d179e;
function _init_properties_SchedulingFeatureModule_kt__cs82uc() {
  if (!properties_initialized_SchedulingFeatureModule_kt_8d179e) {
    properties_initialized_SchedulingFeatureModule_kt_8d179e = true;
    schedulingFeatureModule = module_0(VOID, schedulingFeatureModule$lambda);
  }
}
function FillScheduleFromTemplateUseCase(templateMutator, shiftAccessor, scheduleMutator) {
  this.o8l_1 = templateMutator;
  this.p8l_1 = shiftAccessor;
  this.q8l_1 = scheduleMutator;
}
function IFillScheduleFromTemplateUseCase() {
}
//region block: exports
export {
  get_schedulingFeatureModule as get_schedulingFeatureModule17t7swguggl5i,
  IFillScheduleFromTemplateUseCase as IFillScheduleFromTemplateUseCase2kd5yvlstvirm,
};
//endregion

